import axios, { AxiosResponse } from 'axios'
import { getHeaders } from 'lib/core/services/magento/client/utils'
import { ServiceDependencies } from 'lib/core/services/magento'

interface CreateAccountMutationInput {
  payload: {
    customer: {
      firstname: string
      lastname: string
      email: string
      extension_attributes?: Record<string, any>
      store_id?: number
    }
    password: string
  }
}

export type CreateAccountMutation = (input: CreateAccountMutationInput) => Promise<AxiosResponse<any>>

export const createCreateAccountMutation = (deps: ServiceDependencies): CreateAccountMutation => async ({ payload }) => {
  return axios.post('/V1/customers', payload, {
    headers: getHeaders()
  })
}
